// Map configuration constants
// Centralized configuration makes it easier to adjust map settings

// Helper function to convert x,y coordinates to Leaflet's lat,lng format
// CRS.Simple uses y,x ordering (lat,lng) so we need to swap them
export const xy = function(x, y) {
    if (Array.isArray(x)) {
        // When doing xy([x, y])
        return [x[1], x[0]];
    }
    // When doing xy(x, y)
    return [y, x];
};

// Map bounds in pixel coordinates [width, height] of the source image
export const MAP_CONFIG = {
    // Image dimensions and bounds
    bounds: [xy(0, 0), xy(1237, 978)],
    imageUrl: '/dist/Dixon_Map-2021-web.svg',

    // Marker configuration
    iconUrl: '/dist/dixon-map-marker.svg',
    iconSize: [20, 20],
    iconAnchor: [8, 8],
    popupAnchor: [0, -8],

    // Zoom configuration
    minZoom: -2,
    maxZoom: 2,
    defaultZoom: null, // Will be calculated to fit bounds

    // Popup configuration
    popupMinWidth: 250,
    popupAutoPan: true,
    popupCloseButton: true,
    popupAutoClose: false,

    // Map initialization options
    mapOptions: {
        // Use simple coordinate system for non-geographic maps
        crs: L.CRS.Simple,

        // Remove Leaflet attribution (can add custom attribution if needed)
        attributionControl: false,

        // Allow fractional zoom levels for smoother zooming
        zoomSnap: 0,

        // Zoom limits
        minZoom: -2,
        maxZoom: 2,

        // Enable scroll wheel zoom (can use 'center' to zoom from center)
        scrollWheelZoom: false,

        // Enable dragging on all devices including mobile
        dragging: true,

        // Enable tap interactions on mobile
        tap: true,

        // Show zoom controls for better accessibility
        zoomControl: true,

        // Position zoom controls
        zoomControlPosition: 'topright'
    },

    // Debounce delay for resize events (milliseconds)
    resizeDebounce: 250
};

export default MAP_CONFIG;
